import { roundToScale } from '@/shared'

export const roundQuantity = <T extends number|null|undefined>(value: T) => roundToScale(value, 5)